module.exports = __webpack_public_path__ + "img/retrofit-6.130f0bb1.jpg";